/* eslint-disable no-unused-vars */
export enum GameType {
    LINEAR = 'linear',
    TOGETHER = 'together'
}
